import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-hs-property-inspections.component.scss';
var FormItemHsPropertyInspections = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemHsPropertyInspections, _super);
    function FormItemHsPropertyInspections(element) {
        return _super.call(this, element) || this;
    }
    FormItemHsPropertyInspections.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.submitBtn = this.element.querySelector(".js-hs-property-inspections__button");
        this.buyOwnSelect = Array.from(this.element.querySelectorAll("input[name=buying-own]"));
        this.homeLoanPreQualifySelect = Array.from(this.element.querySelectorAll("input[name=home-loan-pre-qualify]"));
        this.hasSbHomeLoanBuildingInsuranceSelect = Array.from(this.element.querySelectorAll("input[name=has-sb-home-loan-building-insurance]"));
        this.initialsInput = this.element.querySelector("input[name=initials]");
        this.initialsInput.setAttribute("maxLength", "3");
        this._buyOwnSelectValue = "BUYING";
        this._homeLoanPreQualifySelectValue = "NO";
        this._hasSbHomeLoanBuildingInsuranceSelectValue = "NO";
        if (this.buyOwnSelect) {
            this.updateFormBuyOwn(this._buyOwnSelectValue);
        }
    };
    FormItemHsPropertyInspections.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            _this.hsPropertyInspectionsValidations();
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        if (this.buyOwnSelect) {
            this.buyOwnSelect.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    _this._buyOwnSelectValue = _radio.value;
                    _this.updateFormBuyOwn(_this._buyOwnSelectValue);
                });
            });
        }
        if (this.homeLoanPreQualifySelect) {
            this.homeLoanPreQualifySelect.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    _this._homeLoanPreQualifySelectValue = _radio.value;
                });
            });
        }
        if (this.hasSbHomeLoanBuildingInsuranceSelect) {
            this.hasSbHomeLoanBuildingInsuranceSelect.map(function (_radio) {
                _radio.addEventListener('change', function (event) {
                    _this._hasSbHomeLoanBuildingInsuranceSelectValue = _radio.value;
                });
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (e) {
            var success = _this.element.querySelector(".form__success--container");
            if (success) {
                success.classList.remove("active");
            }
            var valid = Array.from(_this.form.querySelectorAll(".form__group--error"));
            valid.map(function (pElem) {
                pElem.classList.remove("form__group--error");
                var errorMessage = pElem.querySelector(".form__group--error_message");
                if (errorMessage) {
                    errorMessage.remove();
                }
            });
            _this.resetForm();
        }, false);
    };
    FormItemHsPropertyInspections.prototype.updateFormBuyOwn = function (type) {
        if (this.homeLoanPreQualifySelect && this.hasSbHomeLoanBuildingInsuranceSelect) {
            var _homeLoanPreQualifySelectGroup = this.homeLoanPreQualifySelect[0].closest(".form__group");
            var _hasSbHomeLoanBuildingInsuranceSelectGroup = this.hasSbHomeLoanBuildingInsuranceSelect[0].closest(".form__group");
            if (type === "BUYING") {
                _homeLoanPreQualifySelectGroup.classList.remove("form__group--hidden");
                _hasSbHomeLoanBuildingInsuranceSelectGroup.classList.add("form__group--hidden");
            }
            else if (type === "OWN") {
                _homeLoanPreQualifySelectGroup.classList.add("form__group--hidden");
                _hasSbHomeLoanBuildingInsuranceSelectGroup.classList.remove("form__group--hidden");
            }
            else {
                _homeLoanPreQualifySelectGroup.classList.add("form__group--hidden");
                _hasSbHomeLoanBuildingInsuranceSelectGroup.classList.add("form__group--hidden");
            }
        }
    };
    FormItemHsPropertyInspections.prototype.submitForm = function (form) {
        // analytics
        var analyticsService = new AnalyticsService();
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // additional containers
        var success = form.querySelector(".form__success--container");
        var preQualifyDecline = form.querySelector(".form__declined--container");
        var homeLoanDecline = form.querySelector(".form__declined--container2");
        var error = form.querySelector(".form__error--container");
        var postData = "";
        var serviceType = form.querySelector("input[name=serviceType]");
        if (serviceType) {
            postData += "service-type=" + serviceType.value;
        }
        var product = form.querySelector("input[name=product]");
        if (product) {
            postData += "&product=" + product.value;
        }
        var description = form.querySelector("input[name=description]");
        if (description) {
            postData += "&description=" + description.value;
        }
        var email = form.querySelector("input[name=email]");
        if (email) {
            postData += "&email=" + email.value;
        }
        var recipient = form.querySelector("input[name=recipient]");
        if (recipient) {
            postData += "&recipient=" + recipient.value;
        }
        var subject = form.querySelector("input[name=subject]");
        if (subject) {
            postData += "&subject=" + subject.value;
        }
        var redirect = form.querySelector("input[name=redirect]");
        if (redirect) {
            postData += "&redirect=" + redirect.value;
        }
        var _title = this.form.querySelector("select[name=name-title]");
        if (_title) {
            postData += "&title=" + _title.value;
        }
        var _initials = this.form.querySelector("input[name=initials]");
        if (_initials) {
            postData += "&initials=" + _initials.value.toUpperCase();
        }
        var _surname = this.form.querySelector("input[name=last-name]");
        if (_surname) {
            postData += "&surname=" + _surname.value;
        }
        var _contact = this.form.querySelector("input[name=contact-number]");
        if (_contact) {
            postData += "&contact=" + _contact.value;
        }
        var _email = this.form.querySelector("input[name=email-address]");
        if (_email) {
            postData += "&emailAddress=" + _email.value;
        }
        var _numberOfRooms = this.form.querySelector("input[name=number-of-rooms]");
        if (_numberOfRooms) {
            postData += "&numberOfRooms=" + _numberOfRooms.value;
        }
        var _buyingOwn = this._buyOwnSelectValue;
        var _homeLoanPreQualify = this._homeLoanPreQualifySelectValue;
        var _hasSbHomeLoanBuildingInsurance = this._hasSbHomeLoanBuildingInsuranceSelectValue;
        if (_buyingOwn) {
            postData += "&buyingOwn=" + _buyingOwn;
            if (_buyingOwn === "BUYING") {
                if (_homeLoanPreQualify !== '') {
                    postData += "&homeLoanPreQualify=" + this._homeLoanPreQualifySelectValue;
                    postData += "&hasHomeLoanOrBuildingInsurance=";
                }
            }
            else if (_buyingOwn === "OWN") {
                if (_hasSbHomeLoanBuildingInsurance !== '') {
                    postData += "&homeLoanPreQualify=";
                    postData += "&hasHomeLoanOrBuildingInsurance=" + this._hasSbHomeLoanBuildingInsuranceSelectValue;
                }
            }
        }
        var _idNumber = this.form.querySelector("input[name=identification]");
        if (_idNumber) {
            postData += "&idNumber=" + _idNumber.value;
        }
        var _streetNameAndNumber = this.form.querySelector("input[name=street-number-address-name]");
        if (_streetNameAndNumber) {
            postData += "&streetNameAndNumber=" + _streetNameAndNumber.value;
        }
        var _unitNumber = this.form.querySelector("input[name=unit-number]");
        if (_unitNumber) {
            postData += "&unitNumber=" + _unitNumber.value;
        }
        var _complexName = this.form.querySelector("input[name=complex-name]");
        if (_complexName) {
            postData += "&complexName=" + _complexName.value;
        }
        var _suburb = this.form.querySelector("input[name=suburb]");
        if (_suburb) {
            postData += "&suburb=" + _suburb.value;
        }
        var _town = this.form.querySelector("input[name=city-town]");
        if (_town) {
            postData += "&town=" + _town.value;
        }
        var _province = this.form.querySelector("select[name=province]");
        if (_province) {
            postData += "&province=" + _province.value;
        }
        var _postalCode = this.form.querySelector("input[name=postal-code]");
        if (_postalCode) {
            postData += "&postalCode=" + _postalCode.value;
        }
        var _consent = this.form.querySelector("input[name=consent]");
        if (_consent) {
            var hasConsent = (_consent.checked) ? 'YES' : 'NO';
            postData += "&consent=" + hasConsent;
        }
        // loader + hide form
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        if (_buyingOwn === "BUYING" && _homeLoanPreQualify === "NO") {
            // end application
            analyticsService.dtmFormComplete('complete', '200');
            analyticsService.rejectedDtmApplication('200', 'Decline');
            loader.classList.remove('active');
            thankYou.classList.add('active');
            error.classList.remove('active');
            error.classList.add('hidden');
            success.classList.remove('active');
            success.classList.add('hidden');
            homeLoanDecline.classList.remove('active');
            homeLoanDecline.classList.add('hidden');
            preQualifyDecline.classList.add('active');
            preQualifyDecline.classList.remove('hidden');
        }
        else if (_buyingOwn === "OWN" && _hasSbHomeLoanBuildingInsurance === "NO") {
            // end application
            analyticsService.dtmFormComplete('complete', '200');
            analyticsService.rejectedDtmApplication('200', 'Decline');
            loader.classList.remove('active');
            thankYou.classList.add('active');
            error.classList.remove('active');
            error.classList.add('hidden');
            success.classList.remove('active');
            success.classList.add('hidden');
            preQualifyDecline.classList.remove('active');
            preQualifyDecline.classList.add('hidden');
            homeLoanDecline.classList.add('active');
            homeLoanDecline.classList.remove('hidden');
        }
        else {
            // variables
            var url_1 = "/services/genericform.jsp";
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'Access-Control-Allow-Origin': '*',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            };
            // service
            this.formsService.postForm(url_1, postData, config).then(function (response) {
                loader.classList.remove('active');
                // Always show success message / no response from server (sending email)
                analyticsService.dtmFormComplete('complete', response.code);
                thankYou.classList.add('active');
                error.classList.remove('active');
                error.classList.add('hidden');
                preQualifyDecline.classList.remove('active');
                preQualifyDecline.classList.add('hidden');
                homeLoanDecline.classList.remove('active');
                homeLoanDecline.classList.add('hidden');
                success.classList.remove('hidden');
                success.classList.add('active');
            }).catch(function (response) {
                // service failed
                analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url_1);
                loader.classList.remove('active');
                fieldsContainer.classList.remove('hidden');
            });
        }
    };
    // -- CUSTOM HOME SERVICES PROPERTY INSPECTIONS VALIDATIONS -- //
    FormItemHsPropertyInspections.prototype.hsPropertyInspectionsValidations = function () {
        var radioDetailsErrorDetails = "This field is required";
        var validationErrors = false;
        // Radio Details Selection Error
        var buyOwnSelectionGroup = this.buyOwnSelect[0].closest(".form__group");
        var homeLoanPreQualifySelectionGroup = this.homeLoanPreQualifySelect[0].closest(".form__group");
        var hasSbHomeLoanBuildingInsuranceSelectionGroup = this.hasSbHomeLoanBuildingInsuranceSelect[0].closest(".form__group");
        // Buy Own Details Selection Error
        if (!buyOwnSelectionGroup.classList.contains("form__group--hidden")) {
            if (this._buyOwnSelectValue === "") {
                validationErrors = true;
                buyOwnSelectionGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioDetailsErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                buyOwnSelectionGroup.appendChild(_errorDiv);
            }
        }
        // Home Loan Pre-Qualify Details Selection Error
        if (!homeLoanPreQualifySelectionGroup.classList.contains("form__group--hidden")) {
            if (this._homeLoanPreQualifySelectValue === "") {
                validationErrors = true;
                homeLoanPreQualifySelectionGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioDetailsErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                homeLoanPreQualifySelectionGroup.appendChild(_errorDiv);
            }
        }
        // Has Home Loan or Business Insurance Details Selection Error
        if (!hasSbHomeLoanBuildingInsuranceSelectionGroup.classList.contains("form__group--hidden")) {
            if (this._hasSbHomeLoanBuildingInsuranceSelectValue === "") {
                validationErrors = true;
                hasSbHomeLoanBuildingInsuranceSelectionGroup.classList.add("form__group--error");
                var _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _errors = document.createElement("ul");
                _errorDiv = document.createElement("div");
                _errorDiv.classList.add("form__group--error_message");
                var _error = document.createElement("li");
                _error.innerHTML = radioDetailsErrorDetails;
                _errors.appendChild(_error);
                _errorDiv.appendChild(_errors);
                hasSbHomeLoanBuildingInsuranceSelectionGroup.appendChild(_errorDiv);
            }
        }
    };
    FormItemHsPropertyInspections.prototype.resetForm = function () {
        // success screens
        var loader = this.form.querySelector(".form__loader--container");
        var thankYou = this.form.querySelector(".form__thankyou--container");
        var fieldsContainer = this.form.querySelector(".form__fields--container");
        // additional containers
        var success = this.form.querySelector(".form__success--container");
        var preQualifyDecline = this.form.querySelector(".form__declined--container");
        var homeLoanDecline = this.form.querySelector(".form__declined--container2");
        var error = this.form.querySelector(".form__error--container");
        this._buyOwnSelectValue = "";
        this._homeLoanPreQualifySelectValue = "";
        this._hasSbHomeLoanBuildingInsuranceSelectValue = '';
        this.updateFormBuyOwn(this._buyOwnSelectValue);
        loader.classList.remove('active');
        thankYou.classList.remove('active');
        success.classList.remove('active');
        success.classList.add('hidden');
        preQualifyDecline.classList.remove('active');
        preQualifyDecline.classList.add('hidden');
        homeLoanDecline.classList.remove('active');
        homeLoanDecline.classList.add('hidden');
        error.classList.remove('active');
        error.classList.add('hidden');
        fieldsContainer.classList.remove('hidden');
    };
    return FormItemHsPropertyInspections;
}(Base));
export { FormItemHsPropertyInspections };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-hs-property-inspections/form-item-hs-property-inspections.component.ts
// module id = 921
// module chunks = 0